import { FORECAST_STRATEGY_DEAL_PROPERTIES, FORECAST_STRATEGY_DEAL_PROPERTIES_FMO_GATED } from '../constants/PortalConfigConstants';
import { propertyLabelTranslator } from 'property-translator/propertyTranslator';
import { hasDealSplit } from './deals';
import { isDealStage } from './dealGroupingUtils';

// TODO: GH #2322: Deals and Goals Sidebar ITs + Util Refactor
export const deriveDealSplitValue = (dealSplit, dealSplitsEnabled) => {
  if (!dealSplitsEnabled) {
    return undefined;
  }
  const dealSplitPercentage = dealSplit.properties.hs_deal_split_percentage && Number(dealSplit.properties.hs_deal_split_percentage.value);

  // By default, percentages are 1 for deals without deal splits
  // We return undefined for non-split deals since splits are irrelevant
  return dealSplitPercentage && dealSplitPercentage !== 1 ? dealSplitPercentage : undefined;
};
export const deriveDealAmount = (deal, dealSplit, portalConfig, dealSplitsEnabled, isFmoEnabled) => {
  var _deal$properties;
  const propertyToUse = isFmoEnabled ? FORECAST_STRATEGY_DEAL_PROPERTIES[portalConfig] : FORECAST_STRATEGY_DEAL_PROPERTIES_FMO_GATED[portalConfig];
  const amount = isFmoEnabled ? deal === null || deal === void 0 ? void 0 : deal[propertyToUse] : Number(deal === null || deal === void 0 || (_deal$properties = deal.properties) === null || _deal$properties === void 0 || (_deal$properties = _deal$properties[propertyToUse]) === null || _deal$properties === void 0 ? void 0 : _deal$properties.value) || 0;
  const dealSplitValue = deriveDealSplitValue(dealSplit, dealSplitsEnabled);
  return hasDealSplit(deal, dealSplitsEnabled) && dealSplitValue ? amount * dealSplitValue : amount;
};
export const deriveDealSidebarAmountValues = (deal, dealSplit, portalConfig, dealSplitsEnabled, isFmoEnabled) => {
  var _dealSplit$properties, _deal$properties2;
  const dealSplitValue = deriveDealSplitValue(dealSplit, dealSplitsEnabled);
  const amount = deriveDealAmount(deal, dealSplit, portalConfig, dealSplitsEnabled, isFmoEnabled);
  return {
    dealSplitValue,
    amount,
    userId: (dealSplit === null || dealSplit === void 0 || (_dealSplit$properties = dealSplit.properties) === null || _dealSplit$properties === void 0 || (_dealSplit$properties = _dealSplit$properties.hs_user_ids_of_all_owners) === null || _dealSplit$properties === void 0 ? void 0 : _dealSplit$properties.value) || (deal === null || deal === void 0 || (_deal$properties2 = deal.properties) === null || _deal$properties2 === void 0 || (_deal$properties2 = _deal$properties2.hs_user_ids_of_all_owners) === null || _deal$properties2 === void 0 ? void 0 : _deal$properties2.value)
  };
};
export const deriveForecastCategoryLabel = (properties, forecastCategoryOptions) => {
  if (!properties.hs_manual_forecast_category || !properties.hs_manual_forecast_category.value) {
    return undefined;
  }
  const categoryOptionForProperty = forecastCategoryOptions.find(option => {
    // Type predicate because DealGroupings is a union type
    if (isDealStage(option)) {
      return false;
    }
    return option.value === properties.hs_manual_forecast_category.value;
  });

  // Adding this extra check in the edge case of a deleted forecast category being searched for and the above check having no match
  return categoryOptionForProperty ? propertyLabelTranslator(categoryOptionForProperty.label) : undefined;
};
export const deriveDealSidebarDisplayValues = (deal, forecastCategoryOptions, dealStages) => {
  var _dealStages$find;
  const dealStageLabel = propertyLabelTranslator(((_dealStages$find = dealStages.find(stage => {
    var _deal$properties3;
    return stage.stageId === (deal === null || deal === void 0 || (_deal$properties3 = deal.properties) === null || _deal$properties3 === void 0 || (_deal$properties3 = _deal$properties3.dealstage) === null || _deal$properties3 === void 0 ? void 0 : _deal$properties3.value);
  })) === null || _dealStages$find === void 0 ? void 0 : _dealStages$find.label) || '');
  return {
    categoryLabel: deriveForecastCategoryLabel(deal === null || deal === void 0 ? void 0 : deal.properties, forecastCategoryOptions),
    dealStageLabel
  };
};